// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"ace8b2c8","198":"0602bf2b","482":"1af8b2a7","498":"d831b7ba","703":"e1f80e5f"}[chunkId] + ".chunk.js";
};